import { useAppStore } from '@/inertia/AppStore';
import { Analytics } from './analytics';
import InfoBox from './infobox';
import ZnglyInbound from './znglyInbound';

// biome-ignore lint/complexity/noStaticOnlyClass: I want this as a class
export class TelemetryRunner {
  private static hasRun = false;
  private static hasGtagLoaded = false;
  private static dataLayerLoadedFns: (() => void)[] = [];

  private static interval: number | null = null;

  public static getHasGtagLoaded = () => TelemetryRunner.hasGtagLoaded;

  public static run(): void {
    if (TelemetryRunner.hasRun) return;
    TelemetryRunner.hasRun = true;

    // add infobox data to the datalayer before the page is loaded
    // we want to do this as early as possible, before the page is loaded
    // new user is calculated on page load apparently
    new InfoBox();

    if (window?.umami) {
      // @ts-ignore
      window.umami.identify({
        client_id: Analytics.getClientId(),
      });
    }

    if (useAppStore.getState()?.isDashboard === false) {
      // custom events
      new ZnglyInbound();
    }

    // add a check for gtag.load after 2 seconds in case it hasn't loaded yet
    TelemetryRunner.interval = window.setInterval(() => {
      if (window.document.hidden) {
        return;
      }

      const dataLayerCheck = TelemetryRunner.dataLayerLoadedCheck();
      if (dataLayerCheck === true) {
        TelemetryRunner.addGtagLoadedFunction(() => {});
        if (TelemetryRunner.interval) {
          clearInterval(TelemetryRunner.interval);
        }
      }
    }, 1000);
  }

  public static addGtagLoadedFunction = (fn: () => void) => {
    if (TelemetryRunner.hasGtagLoaded === true) {
      fn();
      return;
    }

    // datalayer has not loaded yet, add the function to the array
    TelemetryRunner.dataLayerLoadedFns.push(fn);

    // check if gtm.load has already been pushed to the datalayer
    const dataLayerCheck = TelemetryRunner.dataLayerLoadedCheck();
    if (dataLayerCheck === true) {
      TelemetryRunner.hasGtagLoaded = true;
      TelemetryRunner.dataLayerLoadedFns.forEach((fn, idx) => setTimeout(fn, 10 + (idx + 1)));
      TelemetryRunner.dataLayerLoadedFns = [];
    }
  };

  // check if there is a gtm.load event in the datalayer
  private static dataLayerLoadedCheck = (): boolean => {
    if (window.dataLayer && window?.dataLayer?.length > 0) {
      return window?.dataLayer?.some((item) => typeof item === 'object' && item?.event === 'gtm.load');
    }

    return false;
  };
}
